import { cn } from "../lib/format";

export default function SectionHeading({
  eyebrow,
  title,
  copy,
  align = "left",
  invert = false,
}) {
  return (
    <div className={cn("max-w-3xl space-y-4", align === "center" && "mx-auto text-center")}>
      {eyebrow ? <div className={invert ? "eyebrow" : "eyebrow-light"}>{eyebrow}</div> : null}
      <h2 className={invert ? "headline-invert" : "section-title"}>{title}</h2>
      {copy ? <p className={invert ? "text-base leading-7 text-white/70 sm:text-lg" : "muted-copy"}>{copy}</p> : null}
    </div>
  );
}
